// @flow
import type {AjaxActionType} from 'constants/flow/flowTypes';
import {PRODUCT} from 'constants/actions';
import {productAdapter} from '../productAdapter/productAdapter';

const initialState = {
    isError: false,
};

/**
 * Product reducer
 * @param {object} state Current state
 * @param {AjaxActionType} action Received action
 * @returns {{}} state New state
 */
export default function product(state: {} = initialState, action: AjaxActionType): {} {
    switch (action.type) {
        case `${PRODUCT.GET_PRODUCT}_FULFILLED`:
            // TODO appliedCoupons the field will fix in another the task by me
            return {...productAdapter(action.payload.data), preloaded: false, status: 'fulfilled'};
        case `${PRODUCT.GET_PRODUCT}_REJECTED`:
            return {...state, isError: true};
        case `${PRODUCT.GET_PRODUCT}_PENDING`:
            return {...state, status: 'pending'};
        case PRODUCT.SET_PRODUCT:
            return {...action.payload, status: 'fulfilled', preloaded: true};
        case PRODUCT.CLEAR_PRODUCT:
            return {status: '', preloaded: false};
        default:
            return state;
    }
}
